export const TextFonts =
  "-apple-system, BlinkMacSystemFont, “Segoe UI”, “Roboto”, “Oxygen”, “Ubuntu”, “Cantarell”, “Fira Sans”, “Droid Sans”, “Helvetica Neue”, sans-serif";
export const CodeFonts =
  'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace';
